/* istanbul ignore file */
export { default } from './LoginGuestCheckout';
